<template>
  <div class="treatment-page" :dir="direction">
    <app-header/>


    <lab-treatment-view v-if="selectedTreatment && selectedTreatment._id"/>


  </div>
</template>

<script>
import {mapState, mapGetters} from 'vuex'
import AppHeader from '../components/Header'
import LabTreatmentView from '../components/LabTreatmentView'
import UIUtils from '../../business/utils/UIUtils'
import {TREATMENT_PAGE_VIEWS} from '../../business/const'

export default {
  name: 'MainView',
  components: {
    LabTreatmentView,
    AppHeader
  },
  computed: {
    ...mapState({
      selectedTreatment: state => state.timelapse.selectedTreatment
    }),
    ...mapGetters({
      direction: 'locale/direction',
      topRankedWells: 'timelapse/topRankedWells'
    })
  },
  async mounted() {
    const {treatment_id} = this.$route.params
    this.$log.navigationEvent('goto_treatment_page', treatment_id)

    const {view} = this.$route.query
    const {WELL_CARDS} = TREATMENT_PAGE_VIEWS

    await this.$store.dispatch('navigation/switchTreatmentView', view || WELL_CARDS)

    if (!this.selectedTreatment || this.selectedTreatment._id !== treatment_id) {
      await this.loadTreatment()
    }
  },
  methods: {
    async loadTreatment() {
      UIUtils.showLoadingMask()

      const {treatment_id, patient_id} = this.$route.params

      await this.$store.dispatch('timelapse/loadPatientData', patient_id)
      await this.$store.dispatch('timelapse/setSelectedTreatment', treatment_id)

      this.setSelectedSlide()

      UIUtils.hideLoadingMask()

      this.setWellsToCompare()
    },
    setSelectedSlide() {
      const slideId = decodeURIComponent(this.$route.query.slide_id)

      const {slides} = this.selectedTreatment
      let slide = null

      if (slideId) {
        slide = slides.find(slide => slide._id === slideId)
      }

      if (!slide && slides.length) {
        slide = slides[0]
      }

      if (slide) {
        this.$store.commit('timelapse/setSelectedSlide', slide)
        this.$store.commit('video/playState', 'pause')
        this.$store.commit('video/videoSeekMode', 'time')
      }
    },
    setWellsToCompare() {
      const {sfc} = this.$route.query
      const {wellsByIndex} = this.selectedTreatment
      let wells = []

      if (sfc) {
        const wellsIds = sfc.split(',')
        wells = wellsIds.map(wellId => wellsByIndex.find(well => well._id === wellId))
      } else {
        // set top-ranked as fallback
        wells = this.topRankedWells
      }
      const wellIds = wells.map(well => well._id)
      this.$store.dispatch('timelapse/setSelectedForComparison', wellIds)
    }
  }
}
</script>

<style lang="scss" scoped>
.treatment-page {
  position: relative;
  height: 100%;

  .lab-treatment-view {
    height: calc(100% - #{$header-height});
  }
}
</style>
